(() => {
  if (customElements.get("addons-slider")) {
    return;
  }

  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  class AddonsSlider extends HTMLElement {
    constructor() {
      super();
      this.desktopMatchQuery = window.matchMedia("(min-width:770px)");
      this.sliderInstance = undefined;
      this.options = {
        slidesPerView: 1,
        spaceBetween: 20,
        scrollbar: {
          el: `${this.dataset.selector} .swiper-scrollbar`,
          draggable: true,
        },
        navigation: {
          nextEl: `${this.dataset.selector} .swiper-button-next`,
          prevEl: `${this.dataset.selector} .swiper-button-prev`,
        },
      };
    }

    addHandlers() {
      this.handleResize = debounce(() => {
        this.initSlider();
      }, 500).bind(this);
      window.addEventListener("resize", this.handleResize);
    }

    initSlider() {
      if (!this.slider) return;
      if (this.desktopMatchQuery.matches) {
        if (this.sliderInstance !== undefined)
          this.sliderInstance.destroy(true, true);
        return;
      }

      this.sliderInstance = new Swiper(this.dataset.selector, this.options);
    }

    connectedCallback() {
      this.slider = this.querySelector(this.dataset.selector);
      this.addHandlers();
      this.initSlider();
    }
  }

  customElements.define("addons-slider", AddonsSlider);
})();
